import {
    IonAvatar,
    IonCol, 
    IonIcon,
    IonImg,
    IonItem,
    IonLabel,
    IonNote,
    IonRow,
    IonThumbnail
} from '@ionic/react';
import { arrowForwardCircleOutline } from 'ionicons/icons';

import React, { Component }  from 'react';

export interface AddressData {
    id : number,
    address : string
}

interface AddItemProp {
    address : AddressData;
    onClick : any
}
  
const AddressItem: React.FC<AddItemProp> = ({ address, onClick }) => {
    return (
        <IonItem button onClick={ () => { onClick(address.address) } } detail={false} lines="none">
            <IonLabel className="ion-text-wrap">
                { address.address }
            </IonLabel>
            <IonIcon slot="end" icon={arrowForwardCircleOutline}/>
        </IonItem>
    );
};
  
export default AddressItem;